import { client } from './client';

export const getTariffList = ({
  requestConfig,
  fuel,
  paymentMethod,
  postcode
}) => {
  return client('tariffs', {
    ...requestConfig,
    method: 'GET',
    params: {
      paymentMethod,
      fuel,
      postcode
    }
  });
};

export const getTariffDetails = ({
  tariffId,
  paymentMethod,
  economy7,
  isTOU,
  fuel,
  postcode,
  requestConfig
}) => {
  return client(`tariffs/${tariffId}`, {
    ...requestConfig,
    method: 'GET',
    params: {
      paymentMethod,
      economy7,
      isTOU,
      fuel,
      postcode
    }
  });
};
